import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { BlogThemePage, buildBlogThemeHead } from "@/pages/BlogThemePage";
import { getPostBySlug, postPath } from "@/lib/blog-posts";
import { getBlogTheme } from "@/lib/blog-themes";

// /blog/<theme> lists a guide theme. Posts used to live at /blog/<post>; those
// URLs 301 to the post's canonical /blog/<theme>/<post>.
export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const theme = getBlogTheme(params.slug);
    if (theme) return { theme };
    const post = getPostBySlug(params.slug);
    if (post) throw redirect({ href: `${postPath(post)}`, statusCode: 301 });
    throw notFound();
  },
  head: ({ params }) => {
    const theme = params?.slug ? getBlogTheme(params.slug) : undefined;
    return theme ? buildBlogThemeHead(theme, "da") : { meta: [{ name: "robots", content: "noindex" }] };
  },
  component: BlogThemeRoute,
  notFoundComponent: () => (
    <div className="mx-auto max-w-2xl px-6 pt-40 pb-32 text-center">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl">Indlægget findes ikke</h1>
      <a
        href="/blog"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-foreground px-6 py-3 text-xs font-medium uppercase tracking-[0.22em] text-background"
      >
        Til bloggen →
      </a>
    </div>
  ),
});

function BlogThemeRoute() {
  const { theme } = Route.useLoaderData();
  return <BlogThemePage theme={theme} />;
}
